import { render } from "./LoginForm.vue?vue&type=template&id=6c37c08f"
import script from "./LoginForm.vue?vue&type=script&lang=js"
export * from "./LoginForm.vue?vue&type=script&lang=js"

import "./LoginForm.vue?vue&type=style&index=0&id=6c37c08f&lang=scss"
script.render = render

export default script